import PageShell from "@/components/feature/PageShell";
import { useSeo } from "@/hooks/useSeo";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import HeroSidePanel from "@/pages/home/components/HeroSidePanel";
import StatsStrip from "@/pages/home/components/StatsStrip";
import NewsSpotlight from "@/pages/home/components/NewsSpotlight";
import WorksShowcase from "@/pages/home/components/WorksShowcase";
import CharacterSpotlight from "@/pages/home/components/CharacterSpotlight";
import ExploreBand from "@/pages/home/components/ExploreBand";

export default function Home() {
  useSeo(
    "age动漫 - 动漫资讯与精彩作品尽在age动漫官网",
    "age动漫为广大动漫爱好者提供最新动漫资讯、精彩作品展示和专业动漫相关内容，涵盖热门动画介绍、角色分析及行业动态，满足您的动漫文化需求。",
    "age动漫,动漫资讯,动漫作品,动画介绍,动漫推荐,角色分析,aege动漫网站",
  );

  return (
    <PageShell>
      <section className="w-full bg-background-100 border-b border-background-200">
        <div className="w-full px-4 md:px-6 lg:px-10 py-5 md:py-8">
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-2 mb-4">
            <div>
              <h1 className="text-lg md:text-xl font-bold text-foreground-950">今天，想看点什么？</h1>
              <p className="text-xs md:text-sm text-foreground-500 mt-1">
                age动漫每日整理最新动漫资讯与精选作品，帮你找到下一部想追的番。
              </p>
            </div>
            <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-background-50 border border-background-200 text-[11px] text-foreground-500 w-fit whitespace-nowrap">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              2026 秋季新番进行中
            </span>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_320px] xl:grid-cols-[minmax(0,1fr)_360px] gap-4 md:gap-5">
            <HeroCarousel />
            <HeroSidePanel />
          </div>
        </div>
      </section>

      <StatsStrip />
      <NewsSpotlight />
      <WorksShowcase />
      <CharacterSpotlight />
      <ExploreBand />
    </PageShell>
  );
}